/** Canonical CMS host vs white-label event domains. */

const CANONICAL_ORIGINS = new Set([
  "https://aivoryems.com",
  "https://www.aivoryems.com",
  "http://localhost:3000",
  "http://localhost:5173",
  "http://127.0.0.1:3000",
  "http://127.0.0.1:5173",
]);

const OPERATOR_PATH_PREFIXES = ["/login", "/signup", "/admin", "/platform", "/onsite"];

export function getCanonicalOrigin() {
  const fromEnv = String(process.env.REACT_APP_CANONICAL_ORIGIN || "").trim().replace(/\/$/, "");
  if (fromEnv) return fromEnv;
  if (typeof window !== "undefined") {
    const host = String(window.location.hostname || "").toLowerCase();
    if (host === "localhost" || host.endsWith(".localhost") || /^\d+\.\d+\.\d+\.\d+$/.test(host)) {
      return window.location.origin;
    }
  }
  return "https://aivoryems.com";
}

export function isCanonicalHost() {
  if (typeof window === "undefined") return true;
  const host = String(window.location.hostname || "").toLowerCase();
  if (!host) return true;
  if (host === "localhost" || host.endsWith(".localhost")) return true;
  if (host === "aivoryems.com" || host === "www.aivoryems.com") return true;
  if (/^\d+\.\d+\.\d+\.\d+$/.test(host)) return true;
  const origin = String(window.location.origin || "").replace(/\/$/, "");
  if (CANONICAL_ORIGINS.has(origin)) return true;
  return false;
}

/** Custom-domain event sites (e.g. events.example.com) — public only, no CMS auth. */
export function isPublicEventHost() {
  return !isCanonicalHost();
}

export function isOperatorPath(pathname = "") {
  const path = String(pathname || "");
  return OPERATOR_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

/** Send CMS routes to the canonical host (white-label domains are public event sites only). */
export function redirectToCanonicalApp(pathname, search = "") {
  if (typeof window === "undefined" || isCanonicalHost()) return false;
  const path = String(pathname || "/");
  const query = String(search || "");
  const origin = getCanonicalOrigin();
  window.location.replace(`${origin}${path}${query}`);
  return true;
}
